import uniqid from 'uniqid';

export interface AsignedConsultantsFormField {
  name: string;
  label: string;
  renderComponentProps: Record<string, unknown>;
  optionsKey: string;
  key: string;
}

export const ASIGNED_CONSULTANTS_FORM_FIELDS: AsignedConsultantsFormField[] = [
  {
    name: 'principalConsultant',
    label: 'Principal',
    renderComponentProps: {
      'data-testid': 'principal-consultant-input',
    },
    optionsKey: 'fdPrincipal',
    key: uniqid(),
  },
  {
    name: 'contactConsultant',
    label: 'Client Service Contact',
    renderComponentProps: {
      'data-testid': 'contact-consultant-input',
    },
    optionsKey: 'fdClientService',
    key: uniqid(),
  },
  {
    name: 'analystConsultant',
    label: 'Data Analyst',
    renderComponentProps: {
      helperText: 'Internal - not visible to client',
      'data-testid': 'analyst-consultant-input',
    },
    optionsKey: 'fdAnalyst',
    key: uniqid(),
  },
];
